// Header constants
export const VENUE_LISTING_URL = 'https://tally.so/r/n9gP7E';

export const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  PROFILE: '/profile',
  VENUE_LISTS: '/venue-lists',
  EVENTS_INFO: '/events-info',
  VENUES_INFO: '/venues-info'
};

export const MOBILE_MENU_SECTIONS = {
  PLATFORM: 'Our Platform'
};

